module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "dogWalkingModal",
      "data-backdrop": "static",
      "show": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modalBody"
    }
  }, [(_vm.sitterServices.CityId != null) ? _c('DogWalking', {
    attrs: {
      "cityId": _vm.sitterServices.CityId
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12 wrapper-box"
  }, [_c('div', {
    attrs: {
      "name": "sitterServices"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 remove-margins"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("Customize your preferred durations.")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-box  col-xs-12 col-sm-5 large-pad"
  }, [_c('hr', {
    staticStyle: {
      "margin-top": "0px"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterServices.MinimumStayDays),
      expression: "sitterServices.MinimumStayDays"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "pattern": "\\d*",
      "aria-describedby": "sizing-addon2"
    },
    domProps: {
      "value": (_vm.sitterServices.MinimumStayDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sitterServices, "MinimumStayDays", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterServices.MaximumStayDays),
      expression: "sitterServices.MaximumStayDays"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "pattern": "\\d*",
      "aria-describedby": "sizing-addon2"
    },
    domProps: {
      "value": (_vm.sitterServices.MaximumStayDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sitterServices, "MaximumStayDays", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterServices.EarlierThanDays),
      expression: "sitterServices.EarlierThanDays"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "pattern": "\\d*",
      "aria-describedby": "sizing-addon2"
    },
    domProps: {
      "value": (_vm.sitterServices.EarlierThanDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sitterServices, "EarlierThanDays", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterServices.LaterThanDays),
      expression: "sitterServices.LaterThanDays"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "pattern": "\\d*",
      "aria-describedby": "sizing-addon2"
    },
    domProps: {
      "value": (_vm.sitterServices.LaterThanDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sitterServices, "LaterThanDays", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(9)])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("Boarding means you can host pets at your own home, Sitting means you visit pet owner home.")]), _vm._v(" "), _vm._l((_vm.sitterServices.SitterServicesDto), function(service) {
    return _c('div', {
      staticClass: "wrapper-box  col-xs-12 col-sm-5 large-pad",
      class: {
        enabled: service.IsOffered
      }
    }, [_c('h3', {
      class: {
        'new-service': service.ServiceType == 6
      }
    }, [_vm._v(_vm._s(service.Description) + " "), (service.ServiceType == 6) ? _c('span', [_c('i', {
      staticClass: "fa fa-paw"
    }), _vm._v(" New "), (service.IsOffered) ? _c('button', {
      staticClass: "btn btn-info btn-xs pull-right",
      staticStyle: {
        "font-size": "smaller!important"
      },
      attrs: {
        "for": service.Description
      },
      on: {
        "click": function($event) {
          _vm.dogWalkingShow()
        }
      }
    }, [_vm._v("Customize")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (service.Price),
        expression: "service.Price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "pattern": "\\d*",
        "disabled": !service.IsOffered,
        "placeholder": "Enter your price"
      },
      domProps: {
        "value": (service.Price)
      },
      on: {
        "change": function($event) {
          _vm.somethingChanged()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(service, "Price", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_c('strong', {
      staticClass: "h5"
    }, [_vm._v(_vm._s(service.DescriptionPer))])])]), _vm._v(" "), (_vm.sitterServices.CityId == null && service.ServiceType == 6) ? _c('div', [_c('p', {
      staticClass: "small text-danger",
      staticStyle: {
        "margin-top": "8px"
      }
    }, [_vm._v("Please add your location from About page")])]) : _c('div', [_c('li', {
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (service.IsOffered),
        expression: "service.IsOffered"
      }],
      attrs: {
        "type": "checkbox",
        "id": service.Description
      },
      domProps: {
        "checked": Array.isArray(service.IsOffered) ? _vm._i(service.IsOffered, null) > -1 : (service.IsOffered)
      },
      on: {
        "click": function($event) {
          _vm.checkCityId(service)
        },
        "change": [function($event) {
          var $$a = service.IsOffered,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (service.IsOffered = $$a.concat([$$v]))
            } else {
              $$i > -1 && (service.IsOffered = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(service, "IsOffered", $$c)
          }
        }, function($event) {
          _vm.somethingChanged()
        }]
      }
    }), _vm._v(" "), (service.IsOffered) ? _c('label', {
      staticClass: "small",
      staticStyle: {
        "padding-left": "0px"
      },
      attrs: {
        "for": service.Description
      }
    }, [_vm._v("Added to My Profile")]) : _vm._e(), _vm._v(" "), (!service.IsOffered) ? _c('label', {
      staticClass: "small",
      staticStyle: {
        "padding-left": "0px"
      },
      attrs: {
        "for": service.Description
      }
    }, [_vm._v("Add to My Profile")]) : _vm._e()])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-10 col-sm-12  col-xs-12",
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    }
  }, [_c('button', {
    staticClass: "btn large-pad btn-success btn-block btn-lg",
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "0px"
    },
    on: {
      "click": function($event) {
        _vm.updateSitterServices()
      }
    }
  }, [_vm._v(_vm._s(_vm.saveChanges))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("close")])]), _vm._v(" "), _c('h4', [_vm._v("Dog Walking Preference")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "margin-bottom": "0px",
      "margin-top": "10px"
    }
  }, [_vm._v("Stay Duration Filter and Preference "), _c('span', {
    staticClass: "color-orange",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "New Optional Feature, only receive bookings that match your preferences"
    }
  }, [_vm._v("★")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Minimum stay duration "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "If you set this field to 3 days then you will not receive booking requests for 1 or 2 days"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('strong', [_vm._v("Days")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Maximum stay duration "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "If you set this field to 7 days, then you will not receive any booking requests that spans more than 7 days"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('strong', [_vm._v("Days")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Dont receive requests starting before "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "If you set this to 3 days, then you will not receive booking requests that starts tomorrow or in 2 days (0 means you can receive booking requests starting today)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('strong', [_vm._v("Days")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Dont receive requests starting after "), _c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "color": "orange"
    },
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Setting this to 90 days means, you will not receive booking requests starting after 3 months"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('strong', [_vm._v("Days")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("Minimum one service should be added "), _c('span', {
    staticClass: "red-star",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Required to publish your profile"
    }
  }, [_vm._v("★")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d803abb6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/Profile/ServiceRates.vue
// module id = 660
// module chunks = 2